module.exports = __webpack_public_path__ + "img/emile.e10b855.jpeg";